import { defineStore } from "pinia";
import { createIonicStorage, createStorageController, KeyValueStorage } from "@movinglayers/storage";
import { ref } from "vue";

const keys = ["user", "fences"] as const;
const hobbyistStorageIdentifier = "hobbyist";
const tokenStorageIdentifier = "token";

export const useStorageStore = defineStore("storage", () => {
    const controller = ref<ReturnType<typeof createStorageController<typeof keys[number]>>>();
    const tokenStorage = ref<KeyValueStorage>();
    let clearHobbyistStorage = ref<null | (() => Promise<void>)>(null);

    const isStorageInitialized = ref(false);

    const initStorage = async () => {
        if (!isStorageInitialized.value) {
            const [storage, token] = await Promise.all([
                createIonicStorage(hobbyistStorageIdentifier),
                createIonicStorage(tokenStorageIdentifier)
            ]);
            tokenStorage.value = token;
            controller.value = createStorageController(keys, storage);
            clearHobbyistStorage.value = storage.clear;
            isStorageInitialized.value = true;
        }
    };

    return {
        initStorage,
        isStorageInitialized,
        controller,
        clearHobbyistStorage,
        tokenStorage
    };
});